import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import moment from "moment"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils"

export const scheduleList = createAsyncThunk('schedule/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `maintenance_schedule`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                'premise_id': data?.premise_id,
                'zone_id': data?.zone_id,
                'level_id': data?.level_id,
                'asset_id': data?.asset_id,
                'asset_inward_id': data?.asset_inward_id,
                'priority': data?.priority,
                'frequency': data?.frequency,
                'from_date': data?.date_from && moment(data?.date_from, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                'to_date': data?.date_to && moment(data?.date_to, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const scheduleDetails = createAsyncThunk('schedule/details', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `maintenance_schedule/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const delSchedule = createAsyncThunk('schedule/delete', async (data) => {
    try {
        const res = await axios({
            method: 'DELETE',
            url: getConfig.API_URL + `maintenance_schedule/${data?.id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const addSchedule = createAsyncThunk('schedule/add', async (data) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'maintenance_schedule',
            data: {
                "premise_id": data?.values?.premise_id,
                "zone_id": data?.values?.zone_id,
                "level_id": data?.values?.level_id,
                "asset_id": data?.values?.asset_id,
                "asset_inward_id": data?.values?.asset_inward_id,
                "schedule_date": data?.values?.date && moment(data?.values?.date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                "priority": data?.values?.priority,
                "frequency": data?.values?.frequency,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const updateSchedule = createAsyncThunk('schedule/update', async (data) => {
    try {
        const res = await axios({
            method: 'PUT',
            url: getConfig.API_URL + 'maintenance_schedule',
            data: {
                "maintenance_schedule_id": data?.values?.id,
                "priority": data?.values?.priority,
                "frequency": data?.values?.frequency,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const schedule = createSlice({
    name: 'schedule',
    initialState: {
        list: [],
        details: null,
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(scheduleList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate)
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        })

        builder.addCase(scheduleDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.details = action.payload.data.data
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate)
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.details = null
            }
        })
    }
})

export default schedule.reducer;